import React, { useState, useEffect } from "react";
import { Spinner, Alert, Col, Card, Table, ProgressBar } from "react-bootstrap";
import HelperFunction from "../util/helper";
import APIFunction from "../util/api";
import { TIME_FORMAT_OPTIONS  } from "../util/constants";

export default function CashFlow(){
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [transactions, setTransactions] = useState([]);
    const [currentPeriod, setCurrentPeriod] = useState('1m');

    const fetchTransactions = async (period) => {
        try {
          setIsLoading(true);
          setError('');
    
          const response = await APIFunction.getUserTransactionsSummery(period)
        
          setTransactions(response)
        } catch (err) {
          setError(err.message);
        } finally {
          setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactions(currentPeriod);
    }, [currentPeriod]);

    if(isLoading) {
        return <div className="d-flex justify-content-center my-5">
                    <Spinner animation="border" />
                </div>
    }

    if (error) return <Alert variant="danger">{error}</Alert>

    const formatedTotals = HelperFunction.getTotolsRelativeToMax(transactions)

    return (
        <Card className="chart-card">
            <Card.Body>
                <div className="chart-header">
                <h5><i className="bi bi-graph-up"></i> Cashflow</h5>
                <select
                    className="filter-select"
                    value={currentPeriod}
                    onChange={(e) => setCurrentPeriod(e.target.value)} >
                        <option value="1m">This Month</option>
                        <option value="1w">This Week</option>
                        <option value="24h">Today</option>
                        <option value="1y">This Year</option>
                </select>
                </div>
                <div className="chart-info">
                <div className="chart-balance">
                    <span className="chart-label">Transactions Balance</span>
                    <h3>{HelperFunction.formatCurrency(HelperFunction.getTransactionTotals(transactions))}</h3>
                </div>
                <div className="chart-legend">
                    <div className="legend-item">
                    <span className="legend-color income"></span>
                    <span>Deposits</span>
                    </div>
                    <div className="legend-item">
                    <span className="legend-color expense"></span>
                    <span>Withdrawals</span>
                    </div>
                </div>
                </div>
                <div className="chart-placeholder">
                <div className="chart-bars">
                    {formatedTotals.map((tx, i) => (
                    <div key={i} className="chart-bar">
                        <div className="bar-income" style={{ height: `${tx}px` }}></div>
                        {/* <div className="bar-expense" style={{ height: `${Math.random() * 80 + 10}px` }}></div> */}
                    </div>
                    ))}
                </div>
                <div className="chart-months">

                    {transactions.map((tx, i) => (
                        currentPeriod === '1m' ?
                            (i %2 === 0 ?
                            <span key={tx.period}>{HelperFunction.formatDate(tx.period, TIME_FORMAT_OPTIONS.DATE_MONTH_OPTIONS)}</span>
                            :
                            <span></span>)
                        : currentPeriod === '1w' ?
                            (<span key={tx.period}>{HelperFunction.formatDate(tx.period, TIME_FORMAT_OPTIONS.DATE_MONTH_OPTIONS)}</span>)
                        : currentPeriod === '24h' ?
                            (<span key={tx.period}>{HelperFunction.formatDate(tx.period, TIME_FORMAT_OPTIONS.TIME_OPTIONS)}</span>)
                        :
                            (<span key={tx.period}>{HelperFunction.formatDate(tx.period, TIME_FORMAT_OPTIONS.MONTH_NAME_OPTIONS)}</span>)
                    ))}
                </div>
                </div>
            </Card.Body>
        </Card>
    )
}